/* global espn_ui */
import React        from 'react'
import AnchorLink   from './AnchorLink'
//import classNames   from 'classnames'

/* This should be modified to utalise reacts control not the espn_ui */

export default class DropdownList extends React.Component {
  componentDidMount() {
    try{
      const { dropdownDOM = '' } = this.refs
      espn_ui.loadBehaviorNamed('button_dropdown', dropdownDOM)
    } catch(err) {
      console.error(err)
    }
  }

  render() {
    
    const {
      items         = [],
      selected      = '',
      formatUrl,
      classnames,
      dropLeft      = false,
      isSmallDevice = false 
    } = this.props

    let ulClass = 'dropdown-menu med'
    if ( dropLeft ) {
      ulClass += ' drop-left'
    }
    
    let ddClass = 'dropdown-wrapper'
    if ( !isSmallDevice ) {
      ddClass += ' hoverable'
    }

    return (
      <div className={ 'dropdown-wrapper display-desktop hoverable' } data-behavior="button_dropdown" ref="dropdownDOM">
          <button className={ 'button-filter med dropdown-toggle' } type="button">{selected ? selected : '-- select --'}</button>
          <ul className={ ulClass }>
            {
              items.map( (item, i) => {

                let href = item.href || '#'

                if ( typeof formatUrl === 'function' ) {
                  href = formatUrl( item )
                }

                return (
                  <li key={i}>
                    <AnchorLink classes={classnames} to={href} name={item.trackingName} text={item.text} ></AnchorLink>
                  </li>
                )
              })
            }
          </ul>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ../app/components/common/DropdownList.jsx